import { BusMessage, calcStringByteLength, MessageFactory } from "flavr-common";
/**
 * Requests mesh geometry data.
 */
export class RequestMeshGeometryMessage extends BusMessage {
    get byteLength() {
        return calcStringByteLength(this.url) + calcStringByteLength(this.pieceName);
    }
    constructor(url, pieceName) {
        super();
        this.url = url;
        this.pieceName = pieceName;
    }
    serialization(stream) {
        this.url = stream.utf16String(this.url);
        this.pieceName = stream.utf16StringSafe(this.pieceName);
    }
    static is(msg) {
        return msg.type === RequestMeshGeometryMessage.typestatic;
    }
}
RequestMeshGeometryMessage.typestatic = "RequestMeshGeometryMessage";
RequestMeshGeometryMessage.subjectstatic = "selection";
MessageFactory.register(RequestMeshGeometryMessage);
/**
 * Returns mesh geometry data.
 */
export class ResponseMeshGeometryMessage extends BusMessage {
    get byteLength() {
        let byteLength = Uint32Array.BYTES_PER_ELEMENT * 3;
        for (const vertex of this.vertices) {
            byteLength += Uint32Array.BYTES_PER_ELEMENT;
            byteLength += vertex.length * Float32Array.BYTES_PER_ELEMENT;
        }
        for (const index of this.indexes) {
            byteLength += Uint32Array.BYTES_PER_ELEMENT;
            byteLength += index.length * Float32Array.BYTES_PER_ELEMENT;
        }
        for (const matrix of this.matrices) {
            byteLength += Uint32Array.BYTES_PER_ELEMENT;
            byteLength += matrix.length * Float32Array.BYTES_PER_ELEMENT;
        }
        return calcStringByteLength(this.url) + byteLength;
    }
    constructor(url, vertices, indexes, matrices) {
        super();
        this.url = url;
        this.vertices = vertices;
        this.indexes = indexes;
        this.matrices = matrices;
    }
    serialization(stream) {
        this.url = stream.utf16String(this.url);
        if (stream.isReading) {
            this.vertices = [];
            this.indexes = [];
            this.matrices = [];
        }
        let length = stream.uint32(this.vertices.length);
        for (let i = 0; i < length; ++i) {
            if (stream.isReading)
                this.vertices[i] = [];
            const byteLength = stream.uint32(this.vertices[i].length);
            this.vertices[i] = stream.numberFloat32Array(this.vertices[i], byteLength);
            // this.vertices[i] = stream.fastFloat32Array(this.vertices[i]);
        }
        length = stream.uint32(this.indexes.length);
        for (let i = 0; i < length; ++i) {
            if (stream.isReading)
                this.indexes[i] = [];
            const byteLength = stream.uint32(this.indexes[i].length);
            this.indexes[i] = stream.numberFloat32Array(this.indexes[i], byteLength);
            // this.indexes[i] = stream.fastFloat32Array(this.indexes[i]);
        }
        length = stream.uint32(this.matrices.length);
        for (let i = 0; i < length; ++i) {
            if (stream.isReading)
                this.matrices[i] = [];
            const byteLength = stream.uint32(this.matrices[i].length);
            this.matrices[i] = stream.numberFloat32Array(this.matrices[i], byteLength);
            // this.matrices[i] = stream.fastFloat32Array(this.matrices[i]);
        }
    }
    static is(msg) {
        return msg.type === ResponseMeshGeometryMessage.typestatic;
    }
}
ResponseMeshGeometryMessage.typestatic = "ResponseMeshGeometryMessage";
ResponseMeshGeometryMessage.subjectstatic = "selection";
MessageFactory.register(ResponseMeshGeometryMessage);
